import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const buyXgetYDiscountListStyle = StyleSheet.create({
    view: {
        flex: 1,
        backgroundColor: appColors?.lightBackgroundColor
    },
    deleteIconView: {
        alignSelf: "flex-end",
        backgroundColor: appColors.red,
        borderRadius: 28,
        alignItems: "center",
        justifyContent: "center",
        height: 56,
        width: 56,
        position: "absolute",
        bottom: 20,
        right: 20,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 3 },
        shadowOpacity: 0.2,
        shadowRadius: 5,
        elevation: 5,
    },
    contentTextStyle: {
        marginTop: 5
    },
    plusIconView: {
        alignSelf: "flex-end",
        backgroundColor: appColors.primary,
        borderRadius: 28,
        alignItems: "center",
        justifyContent: "center",
        height: 56,
        width: 56,
        position: "absolute",
        bottom: 20,
        right: 20,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 3 },
        shadowOpacity: 0.2,
        shadowRadius: 5,
        elevation: 5,
    },
    countBadgeContainer: {
        position: 'absolute',
        top: -4,
        right: -4,
    },
    badgeView: {
        alignItems: "center",
        borderRadius: 9,
    },
    badgeContainerStyle: {

    },
    iconView: {
        borderWidth: 1,
        borderRadius: 11,
        paddingHorizontal: 10,
        paddingVertical: 10,
        borderColor: appColors.light,
        backgroundColor: appColors.lightBackgroundColor,
    },
    iconStyle: {
        marginTop: 8,
        paddingBottom: 7
    },
    checkBoxView: {
    },
    buttonView: {
        flexDirection: "row",
        alignItems: "center"
    },
    filterView: {
        borderWidth: 0,
        marginHorizontal: 10,
        marginRight: 15,
        marginTop: 10
    },
    filterBadgeContainerStyle: {
        position: "absolute",
        top: -8,
        left: 15,
        paddingHorizontal: 7
    },
    filterBadgeTextStyle: {
        fontFamily: appFonts?.medium,
        fontSize: fontSize?.badgeFontSize
    },
    buttonTitleStyle: {
        fontSize: fontSize?.smallerFontSize,
        fontFamily: appFonts?.bold
    },
    buttonStyle: {
        borderRadius: 10,
        marginTop: 10,
        paddingVertical: 2
    },
    buttonWrapperView: {
        flexDirection: 'row'
    },
    // New responsive card styles
    cardContainer: {
        flex: 1,
        paddingVertical: 14,
        paddingHorizontal: 14,
        backgroundColor: appColors.light,
        borderRadius: 16,
        marginVertical: 6,
        marginHorizontal: 8,
        borderWidth: 1.5,
        borderColor: "transparent",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8,
        elevation: 2,
    },
    cardContainerSelected: {
        borderColor: appColors.primary,
        backgroundColor: "#F4FAFC",
    },
    cardPressed: {
        transform: [{ scale: 0.98 }],
        backgroundColor: '#FAFAFA',
    },
    cardHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
    },
    cardTitleContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
        gap: 8,
    },
    detailsGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 12,
        marginVertical: 10,
        paddingHorizontal: 2,
    },
    detailItem: {
        width: '47%',
        gap: 4,
    },
    detailLabel: {
        fontSize: fontSize.tinyFontSize,
        color: appColors.labelColor,
        fontFamily: appFonts.medium,
    },
    detailValue: {
        fontSize: fontSize.smallFontSize,
        color: appColors.lightDark,
        fontFamily: appFonts.bold,
    },
    actionButtonsRow: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        columnGap: 10,
        marginTop: 8,
        paddingTop: 10,
        borderTopWidth: 1,
        borderTopColor: "#F1F5F9",
    },
    actionButtonEdit: {
        padding: 9,
        backgroundColor: appColors.lightPrimary,
        borderRadius: 20,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "rgba(0, 83, 116, 0.08)",
        minWidth: 38,
        minHeight: 38,
    },
    actionButtonHistory: {
        padding: 9,
        backgroundColor: "#EAF6F8",
        borderRadius: 20,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "rgba(0, 171, 171, 0.08)",
        minWidth: 38,
        minHeight: 38,
    },
    actionButtonStatus: {
        padding: 9,
        backgroundColor: "#FFF4EB",
        borderRadius: 20,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "rgba(255, 133, 23, 0.08)",
        minWidth: 38,
        minHeight: 38,
    },
    actionButtonDelete: {
        padding: 9,
        backgroundColor: "#FEF2F2",
        borderRadius: 20,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "rgba(215, 44, 12, 0.08)",
        minWidth: 38,
        minHeight: 38,
    },
    searchContainerStyle: {
        backgroundColor: appColors.light,
        paddingHorizontal: 10,
        borderRadius: 14,
        height: 48,
        borderWidth: 1,
        borderColor: appColors.borderColor,
    },
    searchInputStyle: {
        color: appColors.lightDark,
        fontSize: fontSize.smallFontSize,
        fontFamily: appFonts.medium,
        paddingLeft: 15
    },
    filterViewStyle: {
        backgroundColor: appColors.lightBackgroundColor,
        padding: 10,
        borderRadius: 14,
        borderColor: appColors.borderColor,
        borderWidth: 1,
        minWidth: 48,
        height: 48,
        justifyContent: "center",
        alignItems: "center",
    },
});